import { useCallback, useContext } from 'react'
import Sheet from 'components/utils/Sheet'
import TextButton from 'LuxKit/Button/TextButton'
import AccountAccessModal from 'components/Account/AccountAccess/AccountAccessModal'
import ModalContext from 'contexts/ModalContext'
import Group from 'components/utils/Group'
import { useIntl } from 'react-intl'

function BedbankMultiRoomLoginCTA() {
  const intl = useIntl()
  const showModal = useContext(ModalContext)

  const onClick = useCallback(() => {
    showModal(<AccountAccessModal initialMode="join" />)
  }, [showModal])

  return <Sheet padding={20} tabletPadding={0} background="normal-background">
    <Group direction="vertical" desktopDirection="horizontal" desktopHorizontalAlign="end">
      <TextButton kind="primary" onClick={onClick} size="large" fit="mobile-full-width">
        {intl.formatMessage({
          id: 'u9_Sqzh7eRKMu1jq3Wou',
          defaultMessage: 'Log in to book this offer',
          description: 'CTA button prompting user to log in to book a bedbank multi-room offer',
        })}
      </TextButton>
    </Group>
  </Sheet>
}

export default BedbankMultiRoomLoginCTA
